import { Transition } from "@headlessui/react"
import Row from "../Grid/Row"
import Column from "../Grid/Column"

const HeroSkeleton = () => (
    <Transition
        show={true}
        enter="transition ease-in-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition ease-in-out duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
    >
        <div className="animate-pulse block rounded-20 -mb-20 bg-white drop-shadow-hero-post">
            <Row>
                <Column xl={6} lg={6} md={6}>
                    <div className="skeleton-animation w-full h-[330px] rounded-tl-20 rounded-bl-20"></div>
                </Column>
                <Column xl={6} lg={6} md={6}>
                    <div className="transition-all ease-in-out duration-300 pr-10 mt-9">
                        <div className="skeleton-animation h-7 w-3/4 mb-5"></div>
                        <div className="skeleton-animation h-7 w-5/6 mb-6"></div>
                        <div className="skeleton-animation h-7 w-3/12 mb-6"></div>
                        <div className="skeleton-animation h-7 w-8/12 mb-6"></div>
                        <div className="skeleton-animation h-7 w-6/12 mb-6"></div>
                    </div>
                </Column>
            </Row>
        </div>
    </Transition>
)

export default HeroSkeleton